import React, {Component, useContext, useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {
    registration,
    registrationLog,
    login,
    logout,
    setFlashError,
    receiveApiTokenWeb3
} from '../../services/user/actions';
import {NavLink} from "react-router-dom";
import Web3Button from "./Web3Button";
function LoginWeb3(props) {
    let date = (new Date("Jul 31 2025")).getTime();
    let today = (new Date()).getTime();
    let msDay = 24 * 60 * 60 * 1000; // milliseconds per day

    let days = Math.floor((date - today) / msDay);
    if (days < 0) {
        days = 0;
    }


        return (
            <div className="App-vertical-center">
            <div className="App-login App-box App-box-light">


                        <div>
                            <h1 className="App-title text-center">Login</h1>

                            {props.flashError && (
                                <p className="text-danger">{props.flashError}</p>
                            )}

                            <div className="custom-w3m-button">
                                <div className="custom-w3m-button__inner">
                                    <Web3Button/>
                                </div>
                            </div>

                            <p className="p-grey mb-15">Suggested wallets</p>
                            <div className="row">
                                <div className="col-4">
                                    <img src="/ui/assets/web3/metamask.svg" className="web3-logo-1"/>
                                </div>
                                <div className="col-4 text-center">
                                    <img src="/ui/assets/web3/rabby.svg" className="web3-logo-2"/>
                                </div>
                                <div className="col-4 text-end">
                                    <img src="/ui/assets/web3/phantom.svg" className="web3-logo-3"/>
                                </div>
                            </div>
                            {days > 0 && (
                                <>
                                    <div className="text-center">
                                        <div className="d-inline-block pl-1">
                                            <NavLink to="/login-legacy" className="link-external">Legacy login
                                                (NeosVR)</NavLink>
                                        </div>
                                        <div className={"pt-2"}>
                                            Available for {days} more days.
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
            </div>
            </div>
        );
}

const mapStateToProps = function (state) {
    return {
        logged: state.user.logged,
        user: state.user.user,
        apiToken: state.user.apiToken,
        is2FA: state.user.is2FA,
        credentials: state.user.credentials,
        flashError: state.user.flashError
    }
};

export default connect(mapStateToProps, {
    registration, login, logout, setFlashError, registrationLog, receiveApiTokenWeb3
})(LoginWeb3);